import { gql } from '@apollo/client'

export const FORGOTPASSWORD = gql`
  mutation Mutation($input: ForgotpasswordInput!, $recaptchaToken: String, $action: ActionInput!) {
    forgotPassword(input: $input, recaptchaToken: $recaptchaToken, action: $action) {
      email
    }
  }
`
export const CHANGEPASSWORD = gql`
  mutation Mutation($input: ChangePasswordInput!, $recaptchaToken: String, $action: ActionInput!) {
    changePassword(input: $input, recaptchaToken: $recaptchaToken, action: $action)
  }
`
